import { Link } from "react-router-dom";
import type { Movie } from "@/lib/types";
import { formatViews } from "@/lib/movies";

interface LatestListProps {
  movies: Movie[];
}

export default function LatestList({ movies }: LatestListProps) {
  return (
    <div className="flex flex-col divide-y divide-background-200/70 border-y border-background-200/70">
      {movies.map((movie) => (
        <Link
          key={movie.id}
          to={`/detail/${movie.id}`}
          className="group flex gap-4 md:gap-5 py-4 md:py-5 cursor-pointer"
        >
          <div className="relative w-[86px] h-[120px] md:w-[104px] md:h-[146px] shrink-0 rounded-md overflow-hidden bg-background-200 border border-background-200/70">
            <img
              src={movie.poster}
              alt={`${movie.title}影视海报`}
              title={`${movie.title}剧情介绍与分析`}
              className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
            />
            <span className="absolute top-1.5 right-1.5 px-1.5 py-0.5 rounded bg-background-50/85 text-[10px] font-label text-accent-500">
              {movie.rating.toFixed(1)}
            </span>
          </div>

          <div className="min-w-0 flex-1">
            <div className="flex flex-wrap items-center gap-2 text-[11px] text-foreground-600">
              <span className="px-1.5 py-0.5 rounded bg-primary-500/20 text-primary-700">
                {movie.type}
              </span>
              <span>{movie.year}</span>
              <span className="w-0.5 h-0.5 rounded-full bg-foreground-700"></span>
              <span>{movie.region}</span>
              <span className="w-0.5 h-0.5 rounded-full bg-foreground-700"></span>
              <span>{movie.language}</span>
            </div>

            <h3 className="mt-2 font-heading text-base md:text-lg font-semibold text-foreground-50 group-hover:text-accent-500 transition-colors">
              {movie.title}
            </h3>

            <p className="mt-1.5 text-xs md:text-sm leading-relaxed text-foreground-500 line-clamp-2">
              {movie.summary}
            </p>

            <div className="mt-2.5 flex flex-wrap items-center gap-x-4 gap-y-1.5 text-[11px] text-foreground-600">
              <span className="inline-flex items-center gap-1">
                <i className="ri-user-star-line"></i>
                {movie.director}
              </span>
              <span className="inline-flex items-center gap-1">
                <i className="ri-eye-line"></i>
                {formatViews(movie.views)}
              </span>
              <span className="hidden sm:inline-flex items-center gap-1 text-foreground-500">
                {movie.genres.slice(0, 3).join(" / ")}
              </span>
            </div>
          </div>

          <div className="hidden md:flex items-center pr-1 text-foreground-700 group-hover:text-accent-500 transition-colors">
            <i className="ri-arrow-right-s-line text-xl"></i>
          </div>
        </Link>
      ))}
    </div>
  );
}